interface ConsultationTypeCardProps {
  type: string;
  duration: string;
  description: string;
  price: string;
  features: string[];
  isPopular?: boolean;
  onSelect: () => void;
}

export default function ConsultationTypeCard({
  type,
  duration,
  description,
  price,
  features,
  isPopular = false,
  onSelect
}: ConsultationTypeCardProps) {
  return (
    <div className={`relative bg-card border-2 ${isPopular ? 'border-primary' : 'border-border'} rounded-xl p-6 hover:shadow-elevated transition-all duration-smooth transform hover:-translate-y-1`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground px-4 py-1 rounded-full text-xs font-semibold">
          Most Popular
        </div>
      )}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-bold text-foreground">{type}</h3>
          <p className="text-sm text-muted-foreground mt-1">{duration}</p>
        </div>
        <p className="text-sm text-foreground">{description}</p>
        <div className="flex items-baseline space-x-2">
          <span className="text-3xl font-bold text-primary">{price}</span>
          {price === "Free" && <span className="text-sm text-muted-foreground">No commitment</span>}
        </div>
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start space-x-2 text-sm text-foreground">
              <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <button
          onClick={onSelect}
          className={`w-full py-3 rounded-lg font-semibold transition-all duration-smooth ${
            isPopular
              ? 'bg-primary text-primary-foreground hover:bg-primary/90'
              : 'bg-secondary text-secondary-foreground hover:bg-secondary/90'
          }`}
        >
          Select {type}
        </button>
      </div>
    </div>
  );
}